module.exports = __webpack_public_path__ + "348622dd.webp";